<!--耗金额统计-->
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="80px">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="queryParam.searchDay"
              type="daterange"
              range-separator=""
              start-placeholder="开始"
              value-format="yyyy-MM-dd"
              end-placeholder="结束">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div></div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="op-con">
        <el-radio-group  v-model="radio" @change="onChangeDay">
          <el-radio :label="0">{{redioDayRange[0].dayDes}}</el-radio>
          <el-radio :label="1">{{redioDayRange[1].dayDes}}</el-radio>
          <el-radio :label="2">{{redioDayRange[2].dayDes}}</el-radio>
          <el-radio :label="3">{{redioDayRange[3].dayDes}}</el-radio>
          <el-radio :label="4">{{redioDayRange[4].dayDes}}</el-radio>
          <el-radio :label="5">{{redioDayRange[5].dayDes}}</el-radio>
          <el-radio :label="6">{{redioDayRange[6].dayDes}}</el-radio>
        </el-radio-group>
        <span class="op-title">(点击立即查询)</span>
      </div>
      <div class="filter-container3" style="height: 360px">
        <div class="consume-item">
          <span class="consume-item-value">消耗正价次数:{{consumeData.consumeCardCounts}}</span>
        </div>
        <div class="consume-item">
          <span class="consume-item-value">消耗赠送次数: {{consumeData.consumeCardGiveCounts}}</span>
        </div>
        <div class="consume-item">
          <span class="consume-item-value">消耗金额:{{consumeData.consumeMoney}}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<style scoped>
  .op-con{
    width: 90%;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fcf4e9;
    border-radius: 8px;
    margin-left: 5%;
  }
  .op-title{
    font-size: 14px;
    font-weight: 500;
    line-height: 45px;
    text-align: center;
    color: #0d6fb8;
    margin-left: 30px;
  }
  .consume-item{
    width: 270px;
    height: 45px;
    background: #ecf3fd;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    margin-top: 5px;
  }
  .consume-item-value{
    font-size: 18px;
    line-height: 45px;
    text-align: center;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import {addReason, delReason, selectall} from "../../../api/cancelBookReason";
  import commonUtils from "../../../utils/commonUtils";
  import messageUtils from "../../../utils/messageUtils";
  import {selectConsumeMoneyData} from "../../../api/bas/basConsumeData";
  import timeUtils from "../../../utils/timeUtils";
  import {formatDate} from "../../../utils/date";
  import enumsUtil from "../../../utils/enumsUtil";


  export default {
    data() {
      return {
        consumeData:"",

        queryParam :{
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          searchDay :[],

        },
        radio: 0,
        redioDayRange:[
          {id: 0, day:[], dayDes:'本周'},
          {id: 1, day:[], dayDes:'本月'},
          {id: 2, day:[], dayDes:'近30天'},
          {id: 3, day:[], dayDes:'近60天'},
          {id: 4, day:[], dayDes:'近半年'},
          {id: 5, day:[], dayDes:'上半年'},
          {id: 6, day:[], dayDes:'下半年'},
          {id: 7, day:[], dayDes:'今年'},
        ],
        redioDay:null,

      }
    },
    created() {
      let now = new Date();
      let monday = timeUtils.getFirstDayOfWeek(now); //周一
      this.queryParam.searchDay = [];
      this.queryParam.searchDay.push(formatDate(monday,"yyyy-MM-dd"));
      this.queryParam.searchDay.push(formatDate(monday,"yyyy-MM-dd"));
      this.initRedioDayRange();
      this.fitchData();
    },
    methods: {


      initRedioDayRange(){
        this.redioDayRange = [];
        let now = new Date();
        let monday = timeUtils.getFirstDayOfWeek(now); //周一
        let rangeItem = {
          day:[formatDate(monday,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"本周"
        }
        this.redioDayRange.push(rangeItem);

        let fm = timeUtils.getFirstDayOfMonth(now); //
        let rangeItemFn = {
          day:[formatDate(fm,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"本月"
        }
        this.redioDayRange.push(rangeItemFn);

        let bf30 = timeUtils.getBeforeDayOfDate(now,30);
        let rangeItembf30 = {
          day:[formatDate(bf30,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"近30天"
        }
        this.redioDayRange.push(rangeItembf30);

        let bf60 = timeUtils.getBeforeDayOfDate(now,60);
        let rangeItembf60 = {
          day:[formatDate(bf60,"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"近60天"
        }
        this.redioDayRange.push(rangeItembf60);



        let bhe = timeUtils.getFirstDayOfHYear(now);
        let rangeItembfHBY = {
          day:[formatDate(bhe[0],"yyyy-MM-dd"),formatDate(bhe[1],"yyyy-MM-dd")],
          dayDes:"上半年"
        }
        this.redioDayRange.push(rangeItembfHBY);

        let ahe = timeUtils.getFirstDayOfLYear(now);

        let rangeItembfABY = {
          day:[formatDate(ahe[0],"yyyy-MM-dd"),formatDate(ahe[1],"yyyy-MM-dd")],
          dayDes:"下半年"
        }

        this.redioDayRange.push(rangeItembfABY);

        let rangeItembfAlly = {
          day:[formatDate(bhe[0],"yyyy-MM-dd"),formatDate(now,"yyyy-MM-dd")],
          dayDes:"全年"
        }
        this.redioDayRange.push(rangeItembfAlly);


      },

      //点击查询按钮
      onBtnSearch(){
        this.fitchData();
      },
      fitchData(){
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId,
          startDay:this.queryParam.searchDay[0],
          lessonTemplateId:enumsUtil.lessonTemplateIdCF(),
          endDay :this.queryParam.searchDay[1],
        }
        const loading = this.myLoading();
        selectConsumeMoneyData(param).then(response =>
        {
          loading.close();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }

          this.refreshData(data);

        })
      },
      refreshData(data){
        if (commonUtils.isObjectNull(data.consumeCardCounts)){
          data.consumeCardCounts = 0;
        }
        if (commonUtils.isObjectNull(data.consumeCardGiveCounts)){
          data.consumeCardGiveCounts = 0;
        }
        if (commonUtils.isObjectNull(data.consumeMoney)){
          data.consumeMoney = 0;
        }
        this.consumeData = data;
      },

      onChangeDay(val){
        let day = this.redioDayRange[val].day;
        this.queryParam.searchDay = [];
        this.queryParam.searchDay.push(day[0]);
        this.queryParam.searchDay.push(day[1]);
        this.fitchData();
      },



    }
  }
</script>






// WEBPACK FOOTER //
// src/views/busness-analysis/consume-card-money/index.vue